module.exports = __webpack_public_path__ + "img/no-search-data.d827694a.png";